export const definingSetupDetails = (tradePlan) => {
  const setup = tradePlan.setup;
  const setupDetails = tradePlan.setupDetails;
  const entryTactics = tradePlan.entryTactics || {};

  switch (setup) {
    case 'BOUNCE':
    case 'ORB':
    case 'FTFC':
      return (
        setup +
        ' - $' +
        Math.round(setupDetails[setup]['priceToBreak'] * 100) / 100
      );
    case 'BREAK':
      return (
        setup +
        ' - $' +
        Math.round(setupDetails[setup]['priceToBreak'] * 100) / 100
      );
    case 'FLAG':
    case 'CANDLE_PATTERN':
    case 'CONVICTION_CANDLE':
      return setup + '-' + setupDetails[setup]['candleDuration'] + 'min';
    case 'CANDLE_TRIGGER':
      return (
        setup +
        '-' +
        setupDetails[setup]['candleDuration'] +
        setupDetails[setup]['timeUnit']
      );
    case 'AD_HOC':
      if (entryTactics['MARKET_ORDER'] !== undefined) {
        return 'MARKET_ORDER';
      }
      if (entryTactics['LIMIT_ORDER'] !== undefined) {
        return 'LIMIT_ORDER';
      }
      if (entryTactics['CANDLE_BREAK'] !== undefined) {
        return (
          'CANDLE_BREAK-' +
          entryTactics['CANDLE_BREAK']['candleDuration'] +
          'min'
        );
      }
      break;
    case 'BOUNCE_EMA':
    case 'BREAK_EMA':
      return (
        setup +
        '-' +
        setupDetails[setup]['candleDuration'] +
        '-' +
        setupDetails[setup]['periodLength']
      );
    case 'BREAK_CANDLE_TYPE':
      return (
        'BREAK' +
        '-' +
        setupDetails[setup]['candleColor'] +
        setupDetails[setup]['candleDuration'] +
        'min'
      );
  }
  return '';
};

export const definingTradeDirection = (tradePlan) => {
  const { goLong, goShort } = tradePlan;
  if (goLong && goShort) {
    return 'BOTH';
  } else if (goLong) {
    return 'LONG';
  } else if (goShort) {
    return 'SHORT';
  }
};

export const determineStatus = (tradePlan) => {
  const { status, inPosition, paused } = tradePlan;
  if (
    !tradePlan.inPosition &&
    tradePlan.restartSystemOncePositionHasFlattened &&
    tradePlan.restartSettings.deactivated
  )
    return 'DEACTIVATED';
  if (!inPosition && paused) return 'PAUSED';
  if (!inPosition && status === 'ARMED') return 'ARMED';
  if (inPosition) return 'ENTERED';
};
